module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/vegan@3x__d469591180482c50bd17e24ce888c46a.png";